import './App.css';
import EmiMfCalculatorAnyMonths from "./EmiMfCalculatorAnyMonths";

function App() {
    return (
        <EmiMfCalculatorAnyMonths/>
    );
}

export default App;
